import React from "react";
import IntFileList from "../component/IntFileList";

const IntFileListContainer = ({ pageId }) => (<IntFileList pageId={pageId}/>)

export default IntFileListContainer;